(function () {
  const WHATSAPP_NUMBER = '584122901033';
  const BUTTON_TEXT = 'Pedir por WhatsApp';
  const WHATSAPP_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="20" height="20" style="margin-right:8px;flex-shrink:0;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.556 4.121 1.528 5.849L.057 23.5l5.797-1.522A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.012-1.374l-.36-.213-3.44.902.92-3.353-.234-.374A9.817 9.817 0 012.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z"/></svg>`;

  const BUTTON_STYLES = `
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: #25D366 !important;
    color: white !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 14px 24px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    width: 100% !important;
    text-decoration: none !important;
    margin-top: 8px !important;
    box-shadow: 0 2px 8px rgba(37,211,102,0.3) !important;
    transition: background-color 0.2s ease !important;
  `;

  function buildMessage(items) {
    let msg = '¡Hola! Estoy interesad@ en saber más sobre los siguientes productos:\n\n';
    items.forEach(function (item, index) {
      const sku = item.sku || 'N/A';
      msg += `${index + 1}. ${item.product_title}, Cantidad: ${item.quantity}, SKU: ${sku}\n`;
    });
    return msg.trim();
  }

  function openWhatsApp(message) {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  function createWhatsAppButton(onClickHandler) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('style', BUTTON_STYLES);
    btn.innerHTML = WHATSAPP_ICON + BUTTON_TEXT;
    btn.addEventListener('mouseover', function () {
      btn.style.backgroundColor = '#1ebe59';
    });
    btn.addEventListener('mouseout', function () {
      btn.style.backgroundColor = '#25D366';
    });
    btn.addEventListener('click', onClickHandler);
    return btn;
  }

  function handleCartWhatsApp(e) {
    e.preventDefault();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          openWhatsApp(buildMessage(cart.items));
        }
      });
  }

  function handleProductWhatsApp(e) {
    e.preventDefault();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          openWhatsApp(buildMessage(cart.items));
        } else {
          const form = document.querySelector('form[action="/cart/add"]');
          if (!form) return;
          const variantId = form.querySelector('[name="id"]')
            ? form.querySelector('[name="id"]').value : null;
          const qty = form.querySelector('[name="quantity"]')
            ? parseInt(form.querySelector('[name="quantity"]').value) || 1 : 1;
          if (!variantId) return;
          fetch(`/variants/${variantId}.js`)
            .then(function (r) { return r.json(); })
            .then(function (variant) {
              openWhatsApp(buildMessage([{
                product_title: variant.name.split(' - ')[0] || variant.name,
                quantity: qty,
                sku: variant.sku || 'N/A'
              }]));
            });
        }
      });
  }

  // El botón nativo lo oculta el CSS del tema, no este script: al cambiar
  // cantidades Shopify re-renderiza el carrito por morphing, que reutiliza los
  // nodos y descarta cualquier estilo inline. Por el mismo motivo no se puede
  // llevar registro de los nodos ya procesados (un WeakSet daba por hecho el
  // trabajo sobre un nodo que el morph había revertido): se comprueba el DOM,
  // de modo que si el re-render se lleva el botón de WhatsApp, se vuelve a poner.
  function ensureWhatsAppButton(anchor, handler, tipo) {
    const parent = anchor.parentNode;
    if (!parent) return;
    if (parent.querySelector('[data-wa-button="' + tipo + '"]')) return;
    const waBtn = createWhatsAppButton(handler);
    waBtn.setAttribute('data-wa-button', tipo);
    parent.insertBefore(waBtn, anchor.nextSibling);
  }

  // --- Reemplazar botón "Pagar" en el carrito ---
  function replaceCartButton() {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      ensureWhatsAppButton(btn, handleCartWhatsApp, 'cart');
    });
  }

  // --- Reemplazar botón "Comprar ahora" en página de producto ---
  function replaceBuyNowButton() {
    document.querySelectorAll(
      '.shopify-payment-button, [data-shopify="payment-button"]'
    ).forEach(function (wrapper) {
      ensureWhatsAppButton(wrapper, handleProductWhatsApp, 'product');
    });
  }

  function init() {
    replaceCartButton();
    replaceBuyNowButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Observer para carrito tipo drawer y elementos dinámicos
  const observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });
})();
